module.exports = __webpack_public_path__ + "static/media/quickstart-step-9.998ec91b.jpg";